import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  IFilterable,
  LayerFilterCategory,
} from 'projects/leaflet/src/public-api';
import { Map } from 'projects/leaflet/src/lib/map';
import { AuthService } from 'projects/frontend/src/app/services/auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { MatDialog } from '@angular/material/dialog';
import { SaveDialogComponent } from 'projects/frontend/src/app/save-dialog/save-dialog.component';
import { FilterService } from 'projects/frontend/src/app/services/filter.service';
import { RotteService } from 'projects/frontend/src/app/services/rotte.service';
@Component({
  selector: 'emodnet-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, IFilterable {

  @Output() filtersChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() menuStateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectedInstitutions: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedPolygon: EventEmitter<any> = new EventEmitter<any>();
  categories?: LayerFilterCategory[];
  isFilterOpen: boolean = true;
  menuInstitutionVisible = false;
  status: boolean = false;
  customId: any;
  currentCustomFilters: any
  public isGaia: boolean = false;
  public isLaura: boolean = false;
  public isRotte: boolean = false;
  public isRotteOpen: boolean = false;
  public rottaSelected: string = '';
  public text = "This page allows you to explore selected datasets in the Data Viewer. Records can be filtered using the options available in the right-hand menu, and the filtered datasets are displayed on the map. By selecting a dataset directly on the map, a platform page will open.For Virtual Access records, the platform page shows key information about the dataset and provides links to the download page and to the POLARIN GeoNetwork. For Data Layers, the platform page allows interaction with the data to access their underlying variables. You can generate plots and charts to analyze the data and access the corresponding download links."


  get token() {
    return this.OAuth.getAccessToken();
  }

  @Input() public set layerFilterCategories(
    v: LayerFilterCategory[] | undefined
  ) {
    this.categories = v;
    this.customId = v ? v[6] : v;
    this.prepareCategories(this.categories);
    this.filtersChanged.emit(true);
  }

  mapInstance?: any;
  @Input() public set map(
    v: Map | undefined
  ) {
    this.mapInstance = v;
  }

  institutionslist: Array<any> = [];
  @Input() public set institutions(
    v: any
  ) {

    if (!v) return;
    this.institutionslist = v;

  }

  constructor(private OAuth: OAuthService, private authService: AuthService, private dialog: MatDialog, private filterService: FilterService, private gaiaService: RotteService) {
    this.filterService.filters.subscribe((res) => {
      this.currentCustomFilters = res;
    })
  }

  ngOnInit(): void {
    this.authService.configureAuth();
    this.authService.isLogged.subscribe((res) => this.status = res);
  }

  institutionsSelected(event: any) {
    this.selectedInstitutions.emit(event)
  }

  private prepareCategories(categories?: LayerFilterCategory[]) {
    categories?.forEach((f) => {
      if (f?.id == 'times')
        f.categories?.forEach((ff) =>
          ff.filters?.forEach((fi: any) => {
            if (ff.name == 'All' || ff.name == 'Custom') return;
            if (fi.value) {
              const filterTime = new Date();
              filterTime.setDate(filterTime.getDate() - fi.value[0].value);
              filterTime.setUTCHours(0, 0, 0, 0);

              const today = new Date();
              today.setDate(today.getDate() + 1);
              today.setUTCHours(0, 0, 0, 0);

              if (filterTime && today) {
                fi.filter = `${filterTime.toISOString()}/${today.toISOString()}`;
              }

            }
          })
        );
      f.filters?.forEach((ff) => (ff.selected = f.selected ?? false));
      this.prepareCategories(f.categories);
    });

  }

  menuStateChange() {
    this.isFilterOpen = !this.isFilterOpen;
    if (this.isFilterOpen) {
      document.documentElement.style.setProperty('--controlPosition', '320px');
    } else {
      document.documentElement.style.setProperty('--controlPosition', '10px');
    }
    this.menuStateChanged.emit(this.isFilterOpen);
  }

  public saveFilter() {
    this.dialog.open(SaveDialogComponent, {
      disableClose: true,
      minWidth: '50vw',
    }).afterClosed().subscribe(async (res: any) => {
      if (res) {
        const filterToSave = await this.createCustomFilterToSave(res);
        localStorage.setItem('custom-filter', JSON.stringify(filterToSave));
        if (this.token) {
          const newId = this.OAuth.getIdentityClaims()['sub'];
          this.filterService.saveLoggedFilter(filterToSave, newId).subscribe(
            (res) => {
              console.log('response', res);
            },
            (error) => {
              console.log('Error on Filter save', error);
            })
        }
      }
    })
  }

  public async createCustomFilterToSave(name: string) {
    let filterToSave = {
      name: name,
      timeFilter: '',
      filters: '',
      color: '#8F4EC1',
      description: 'delete'
    }
    const cqlFilter = this.mapInstance?.overlayLayers[0].wmsParams.cql_filter;
    const currentTime = this.mapInstance?.overlayLayers[0].wmsParams.TIME;
    if (currentTime.includes('/')) {
      const dayOfDifference = ((new Date(currentTime.split('/')[0]).getTime() - new Date(currentTime.split('/')[1]).getTime()) / (24 * 60 * 60 * 1000)) + 1;
      switch (dayOfDifference) {
        case -7:
          filterToSave.timeFilter = '7 days'
          break;

        case -30:
          filterToSave.timeFilter = '30 days'
          break;

        case -365:
          filterToSave.timeFilter = '1 year'
          break;

        default:
          filterToSave.timeFilter = currentTime;
          break;
      }
    }

    filterToSave.filters = cqlFilter.trim();
    filterToSave.timeFilter === '' ? currentTime : filterToSave.timeFilter;
    if (localStorage.length > 0 && localStorage.getItem('custom-filter')) {
      let preSavedFilters = JSON.parse(localStorage.getItem('custom-filter')!);
      preSavedFilters.categories.push(filterToSave);
      this.filterService.sendFilter(preSavedFilters);
      return preSavedFilters;
    } else if (localStorage.length === 0 && !this.currentCustomFilters) {
      const newCategory = {
        name: 'Custom-filter',
        id: 'customFilter',
        exclusive: true,
        categories: [filterToSave],
      };
      this.filterService.sendFilter(newCategory);
      return newCategory;
    } else {
      const newId = this.OAuth.getIdentityClaims()['sub'];
      return this.filterService.getLoggedfilter(newId).subscribe(
        (filters) => {
          return filters
        },
        (error) => {
          console.log('Error on Get Filters');
          return [];
        }
      )
    }
  }

  public onActivateTimeFilter(name: string) {

    const timeCategory = this.categories?.find(cat => cat.id === 'times');
    if (!timeCategory || !timeCategory.categories) return;

    timeCategory.categories.forEach(sub => {
      sub.selected = (sub.name?.toLowerCase() === name);
      sub.filters?.forEach(f => f.selected = sub.selected);
    });
  }

  public onActivateCustom(custom: any) {
    this.customId = custom;
  }

  public openInfoDialog(){
    const dialog = document.getElementById('dialog-webgis') as HTMLDialogElement;
    dialog?.showModal();
  }

  public closeInfoDialog(){
    const dialog = document.getElementById('dialog-webgis') as HTMLDialogElement;
    dialog?.close();
  }
}
